import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PromoBudgetService {
    constructor(
        private apiHttp: ApiHttp) {
    }

    public getBudgets(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoBudget/GetBudgets', data, messageService);
    }

    public getBudget(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoBudget/GetBudget', data, messageService);
    }

    public addOrUpdateBudget(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoBudget/AddOrUpdateBudget', data, messageService);
    }

    public setBudgetActive(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoBudget/SetBudgetActive', data, messageService);
    }

    public topUpBudget(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoBudget/TopUpBudget', data, messageService);
    }
}
